(function () {
  function syncBottomNavThemeVars(shell, bottomNav) {
    if (!shell || !bottomNav) return;

    var computed = getComputedStyle(shell);
    ['--jj-bottom-nav-background', '--jj-bottom-nav-foreground', '--jj-blue'].forEach(function (prop) {
      var value = computed.getPropertyValue(prop).trim();
      if (value) bottomNav.style.setProperty(prop, value);
    });

    var foreground = bottomNav.style.getPropertyValue('--jj-bottom-nav-foreground').trim();
    if (foreground) {
      bottomNav.style.setProperty('--jj-bottom-nav-foreground', foreground);
    }
  }

  function isCustomQuickBuyModalOpen() {
    return Array.from(document.querySelectorAll('.custom-quick-buy-modal')).some(function (modal) {
      return modal.style.display === 'block';
    });
  }

  function isBottomNavOverlayActive(mobileMenu, shell) {
    if (mobileMenu && !mobileMenu.hidden) return true;
    if (shell && shell.hasAttribute('data-menu-open')) return true;
    if (
      document.querySelector(
        'cart-drawer[open], x-drawer[open], x-modal[open], quick-buy-modal[open], .barcode-scanner[open], [data-barcode-scanner-modal][open]'
      )
    ) {
      return true;
    }
    if (document.querySelector('.cart-coupons__overlay.is-open, .cart-coupons__sheet.is-open')) return true;
    return isCustomQuickBuyModalOpen();
  }

  function syncBottomNavOverlayState(bottomNav, mobileMenu, shell) {
    if (!bottomNav) return;

    var overlayActive = isBottomNavOverlayActive(mobileMenu, shell);
    bottomNav.classList.toggle('jj-bottom-nav--overlay-active', overlayActive);
    bottomNav.style.removeProperty('color');
  }

  function initBottomNavOverlaySync(bottomNav, mobileMenu, shell) {
    function sync() {
      syncBottomNavOverlayState(bottomNav, mobileMenu, shell);
    }

    sync();

    if (!window.__jjBottomNavOverlaySync) {
      window.__jjBottomNavOverlaySync = { callbacks: [] };

      document.addEventListener('dialog:before-show', function () {
        window.__jjBottomNavOverlaySync.callbacks.forEach(function (callback) {
          callback();
        });
      });

      document.addEventListener('dialog:after-hide', function () {
        window.__jjBottomNavOverlaySync.callbacks.forEach(function (callback) {
          callback();
        });
      });

      window.__jjBottomNavOverlayObserver = new MutationObserver(function () {
        window.__jjBottomNavOverlaySync.callbacks.forEach(function (callback) {
          callback();
        });
      });

      window.__jjBottomNavOverlayObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['open', 'hidden', 'data-menu-open', 'class', 'style'],
        subtree: true
      });
    }

    window.__jjBottomNavOverlaySync.callbacks.push(sync);
  }

  function initMobileBackButton(shell) {
    var backButton = shell.querySelector('.header__mobile-back-button');
    if (!backButton) return;

    var isMobile = window.matchMedia('(max-width: 1149px)');
    var homeUrl = shell.dataset.jjHomeUrl || '/';

    function hasSameOriginReferrerFromAnotherPage() {
      if (!document.referrer) return false;

      try {
        var currentUrl = new URL(window.location.href);
        var referrerUrl = new URL(document.referrer);
        if (referrerUrl.origin !== currentUrl.origin) return false;

        var currentPath = currentUrl.pathname + currentUrl.search;
        var referrerPath = referrerUrl.pathname + referrerUrl.search;
        return referrerPath !== currentPath;
      } catch (error) {
        return false;
      }
    }

    function canvasAppShouldUseHistoryBack() {
      try {
        return (
          document.documentElement.classList.contains('canvas-app-webview') &&
          typeof window.history.length === 'number' &&
          window.history.length > 1
        );
      } catch (error) {
        return false;
      }
    }

    function updateVisibility() {
      backButton.hidden = !isMobile.matches;
    }

    backButton.addEventListener('click', function () {
      if (hasSameOriginReferrerFromAnotherPage() || canvasAppShouldUseHistoryBack()) {
        window.history.back();
      } else {
        window.location.href = homeUrl;
      }
    });

    updateVisibility();

    if (typeof isMobile.addEventListener === 'function') {
      isMobile.addEventListener('change', updateVisibility);
    } else if (typeof isMobile.addListener === 'function') {
      isMobile.addListener(updateVisibility);
    }
  }

  function initHeader(shell) {
    if (!shell || shell.dataset.jjInitialized === 'true') return;
    shell.dataset.jjInitialized = 'true';

    initMobileBackButton(shell);

    var detailsItems = Array.from(shell.querySelectorAll('[data-jj-nav-details]'));
    var overlay = shell.querySelector('[data-jj-overlay]');
    var mobileMenu = shell.querySelector('[data-jj-mobile-menu]');
    var bottomNav = shell.querySelector('.jj-bottom-nav');
    var openButtons = Array.from(shell.querySelectorAll('[data-jj-mobile-open]'));
    var closeButtons = Array.from(shell.querySelectorAll('[data-jj-mobile-close]'));
    var hoverTimer;
    var previousOverflow = '';

    /* Escape header section stacking context (z-index 30) so nav stays above drawers/modals. */
    if (bottomNav && bottomNav.parentNode !== document.body) {
      syncBottomNavThemeVars(shell, bottomNav);
      document.body.appendChild(bottomNav);
    }

    if (bottomNav) {
      initBottomNavOverlaySync(bottomNav, mobileMenu, shell);

      bottomNav.addEventListener('click', handleBottomNavCartClick, true);

      document.addEventListener('cart:change', function (event) {
        var count = event.detail && event.detail.cart && event.detail.cart.item_count;
        if (typeof count !== 'number') return;

        bottomNav.querySelectorAll('.cart-count-number').forEach(function (el) {
          el.textContent = count;
        });
        bottomNav.querySelectorAll('cart-dot').forEach(function (dot) {
          dot.classList.toggle('is-visible', count > 0);
        });
      });
    }

    function closeDesktopMenus(except) {
      detailsItems.forEach(function (details) {
        if (details !== except) details.open = false;
      });
    }

    function syncDesktopState() {
      var hasOpenMenu = detailsItems.some(function (details) {
        return details.open;
      });

      if (hasOpenMenu) {
        shell.setAttribute('data-menu-open', '');
      } else {
        shell.removeAttribute('data-menu-open');
      }

      syncBottomNavOverlayState(bottomNav, mobileMenu, shell);
    }

    detailsItems.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (details.open) closeDesktopMenus(details);
        syncDesktopState();
      });

      if (shell.dataset.menuTrigger === 'hover') {
        details.addEventListener('pointerenter', function (event) {
          if (event.pointerType === 'touch') return;
          window.clearTimeout(hoverTimer);
          closeDesktopMenus(details);
          details.open = true;
        });

        details.addEventListener('pointerleave', function (event) {
          if (event.pointerType === 'touch') return;
          hoverTimer = window.setTimeout(function () {
            details.open = false;
          }, 120);
        });
      }
    });

    if (overlay) {
      overlay.addEventListener('click', function () {
        closeDesktopMenus();
      });
    }

    document.addEventListener('click', function (event) {
      if (!shell.contains(event.target)) closeDesktopMenus();
    });

    function selectTab(tabHandle) {
      shell.querySelectorAll('[data-jj-mobile-tab]').forEach(function (tab) {
        var isActive = tab.dataset.jjMobileTab === tabHandle;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      shell.querySelectorAll('[data-jj-mobile-panel]').forEach(function (panel) {
        panel.hidden = panel.dataset.jjMobilePanel !== tabHandle;
      });
    }

    function showRootPanels(tabHandle) {
      var roots = shell.querySelector('[data-jj-mobile-roots]');
      if (roots) roots.hidden = false;

      shell.querySelectorAll('[data-jj-mobile-submenu]').forEach(function (submenu) {
        submenu.hidden = true;
      });

      if (tabHandle) selectTab(tabHandle);
      if (mobileMenu) mobileMenu.scrollTop = 0;
    }

    function openMobileMenu() {
      if (!mobileMenu) return;
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      mobileMenu.hidden = false;
      openButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'true');
      });
      showRootPanels();

      syncBottomNavOverlayState(bottomNav, mobileMenu, shell);

      var closeButton = mobileMenu.querySelector('[data-jj-mobile-close]');
      if (closeButton) closeButton.focus();
    }

    function closeMobileMenu(restoreFocus) {
      if (!mobileMenu || mobileMenu.hidden) return;
      mobileMenu.hidden = true;
      document.documentElement.style.overflow = previousOverflow;
      openButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
      syncBottomNavOverlayState(bottomNav, mobileMenu, shell);
      if (restoreFocus !== false && openButtons[0]) openButtons[0].focus();
    }

    function openCartDrawerFromBottomNav() {
      var cartDrawer = document.getElementById('cart-drawer');
      if (cartDrawer && typeof cartDrawer.show === 'function') {
        cartDrawer.show();
      }
    }

    function handleBottomNavCartClick(event) {
      var cartTrigger = event.target.closest('[aria-controls="cart-drawer"]');
      if (!cartTrigger || !mobileMenu || mobileMenu.hidden) return;

      event.preventDefault();
      event.stopPropagation();

      closeMobileMenu(false);

      window.requestAnimationFrame(function () {
        openCartDrawerFromBottomNav();
      });
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (mobileMenu && !mobileMenu.hidden) {
          closeMobileMenu();
        } else {
          openMobileMenu();
        }
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeMobileMenu();
      });
    });

    shell.querySelectorAll('[data-jj-mobile-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        showRootPanels(tab.dataset.jjMobileTab);
      });
    });

    shell.querySelectorAll('[data-jj-mobile-drill]').forEach(function (button) {
      button.addEventListener('click', function () {
        var target = shell.querySelector('#' + CSS.escape(button.dataset.jjMobileDrill));
        var roots = shell.querySelector('[data-jj-mobile-roots]');
        if (!target || !roots) return;

        roots.hidden = true;
        shell.querySelectorAll('[data-jj-mobile-submenu]').forEach(function (submenu) {
          submenu.hidden = submenu !== target;
        });
        mobileMenu.scrollTop = 0;
      });
    });

    shell.querySelectorAll('[data-jj-mobile-back]').forEach(function (button) {
      button.addEventListener('click', function () {
        var submenu = button.closest('[data-jj-mobile-submenu]');
        showRootPanels(submenu ? submenu.dataset.parentTab : '');
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (mobileMenu && !mobileMenu.hidden) {
        closeMobileMenu();
      } else {
        closeDesktopMenus();
      }
    });
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-jj-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
